import { Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
export default function InfoCard({
    obj,
    isExpanded,
    labels,
    onToggle,
    formatValue,
    titelField,
    type,
}) {
    return (
        <Accordion
            key={obj.id}
            expanded={isExpanded}
            onChange={() => onToggle(obj.id)}
            sx={{
                border: "1px solid rgba(255,255,255,.1)",
                background: isExpanded ? "white" : "transparent",
                color: isExpanded ? "black" : "white",
            }}
        >
            <AccordionSummary
                sx={{
                    fontSize: "14px",
                }}
                expandIcon={
                    <ExpandMoreIcon
                        sx={{
                            color: isExpanded ? "black" : "white",
                        }}
                    />
                }
                aria-controls={obj.type}
                id={obj[titelField]}
            >
                <strong>
                    {type === "nut2" && obj.nuts_code + " - "}
                    {obj[titelField]}
                </strong>
            </AccordionSummary>
            <AccordionDetails>
                {Object.entries(obj).map(([key, value]) => {
                    // Only render fields that are explicitly listed in `labels`
                    if (
                        !labels ||
                        !Object.prototype.hasOwnProperty.call(labels, key)
                    ) {
                        return null;
                    }
                    return (
                        <div key={key}>
                            <strong>{labels[key] || key}:</strong>{" "}
                            {formatValue(key, value)}
                        </div>
                    );
                })}
            </AccordionDetails>
        </Accordion>
    );
}
